import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { SNAPSHOT_RANGE } from '../../../config/CalendarRangeSet';
import { CHANNEL_ARRAY_ADMIN_SET, CHANNEL_ARRAY_SET, Channel_CODE_SET } from '../../../config/CgmCodeSet';
import { REPORT_TYPE_SET } from '../../../config/ReportOptionSet';
import { getExpressParams, postExpress } from '../../../service/api';
import SnapshotCreateMain from '../../presentation/section/snapshot-create-page/SnapshotCreateMain';
import JSONtoReportData from '../json-to-chartdata/JSONtoReportData';
import LoadingOverlay from 'react-loading-overlay';
import produce from 'immer';
import AlertModal from '../../presentation/modal/AlertModal';

const toQuerySelectList = (queryList, labelList) => {
  let options = [];

  queryList.info && queryList.info.forEach((queryItem) => {
    let pushItem = {};
    pushItem.value = queryItem.name;
    pushItem.id = queryItem.queryID;
    pushItem.label = `${queryItem.name} (${queryItem.QUERY_TYPE})`
    if(queryItem.label) {
      pushItem.label = `${pushItem.label} (${(labelList.info.filter(labelItem=>labelItem.labelID == queryItem.label)[0].name)})`
    }
    options.push(pushItem)
  })
  
  return options;
}

const toMultiQuerySelectList = (mainQuery, queryList, labelList) => {
  let options = [];
  
  queryList.info.filter((item)=>item.queryID != mainQuery).forEach((queryItem) => {
    let pushItem = {};
    pushItem.value = queryItem.name;
    pushItem.id = queryItem.queryID;
    pushItem.label = `${queryItem.name} (${queryItem.QUERY_TYPE})`
    if(queryItem.label) {
      pushItem.label = `${pushItem.label} (${(labelList.info.filter(labelItem=>labelItem.labelID == queryItem.label)[0].name)})`
    }
    options.push(pushItem)
  })
  
  return options;
}

// const toChannelList = () => {
//   let options = [];
//   // let channelArray = ["social", "blog0", "blog1", "blog2", "blog3", "club0", "club1", "club2", "board0", "prof0", "kin0", "sns0", "twit1", "facebook1", "insta1", "news", "pnews0", "tnews0", "inews0", "bnews0", "enews0", "shop", "ashop0", "gshop0", "eshop0", "cshop0", "wshop0", "tshop0", "youtube", "renews"]
//   let channelArray = ["social", "blog0", "blog1", "blog2", "blog3", "club0", "club1", "club2", "board0", "prof0", "kin0", "sns0", "twit1", "insta1", "video0", "youtube1", "news", "pnews0", "tnews0", "inews0", "bnews0", "enews0", "shop", "ashop0", "gshop0", "eshop0", "cshop0", "wshop0", "tshop0", "renews"]

//   channelArray.forEach(item=>{
//     options.push({
//       value: item,
//       label: Channel_CODE_SET[item]
//     })
//   })

//   return options;
// }

const toReportTypeList = () => {
  let options = [];
  // let reportTypeArray = ["volume", "sentiment", "source", "relation", "category", "positioningmap"];
  let reportTypeArray = ["volume", "sentiment", "source", "category"];

  reportTypeArray.forEach(item=>{
    options.push({
      value: item,
      label: REPORT_TYPE_SET[item]
    })
  })

  return options;
}

const SnapshotCreate = (props) => {
  const [dateRange, setDate] = useState([new Date(), new Date()])
  const [reportType, setReportType] = useState([]);
  const [reportTypeSelectOption, setReportTypeSelectOption] = useState([]);
  // const [channels, setChannels] = useState([]);
  // const [channelSelectOption, setChannelSelectOption] = useState([]);
  const [querySelectOption, setQuerySelectOption] = useState([]);
  const [multiQuerySelectOption, setMultiQuerySelectOption] = useState([]);
  const [queryList, setQueryList] = useState([]);
  const [labelList, setLabelList] = useState([]);
  const [mainQuery, setMainQuery] = useState(null);
  const [subQuery, setSubQuery] = useState([]);
  const [subQueryType, setSubQueryType] = useState("compare");
  const [reTweet, setReTweet] = useState(true)
  const [options, setOptions] = useState({
    timeunit: 'daily',
    datatype: 'numeric',
    rows: '50',
    words: '200',
    morph: 'all',
  })
  const [volumeResult, setVolumeResult] = useState(null);
  const [sentimentResult, setSentimentResult] = useState(null);
  const [sourceResult, setSourceResult] = useState(null);
  const [relationResult, setRelationResult] = useState(null);
  const [categoryResult, setCategoryResult] = useState(null);
  const [positioningmapResult, setPositioningmapResult] = useState(null);
  const [userLabelData, setUserLabelData] = useState([]);

  const [loaded, setLoaded] = useState(true);
  const [loadingText, setLoadingText] = useState(<div>loading</div>);

  const [onDateBtn, setOnDateBtn] = useState('nope')
  const [userRole, setUserRole] = useState('');

  const [alertShow, setAlertShow] = useState(false);
  const handleAlertShow = () => setAlertShow(true);
  const handleAlertClose = () => setAlertShow(false);

  // const [channels, setChannels] = useState(CHANNEL_ARRAY_SET);
  const [channels, setChannels] = useState(props.currentRole=='ROLE_ADMIN' ? (CHANNEL_ARRAY_ADMIN_SET) : (CHANNEL_ARRAY_SET));

  // const [channels, setChannels] = useState([
  //   {
  //     id: "social",
  //     name: "소셜 미디어",
  //     checked: false,
  //     subCh: [
  //       {
  //         id: "blog0",
  //         name: "블로그",
  //         checked: false
  //       },
  //       {
  //         id: "blog1",
  //         name: "네이버 블로그",
  //         checked: false
  //       },
  //       {
  //         id: "blog2",
  //         name: "다음 블로그",
  //         checked: false
  //       },
  //       {
  //         id: "blog3",
  //         name: "티스토리",
  //         checked: false
  //       },
  //       {
  //         id: "club0",
  //         name: "클럽",
  //         checked: false
  //       },
  //       {
  //         id: "club1",
  //         name: "네이버 카페",
  //         checked: false
  //       },
  //       {
  //         id: "club2",
  //         name: "다음 카페",
  //         checked: false
  //       },
  //       {
  //         id: "board0",
  //         name: "게시판",
  //         checked: false
  //       },
  //       {
  //         id: "prof0",
  //         name: "전문사이트",
  //         checked: false
  //       },
  //       {
  //         id: "kin0",
  //         name: "지식검색",
  //         checked: false
  //       },
  //       {
  //         id: "sns0",
  //         name: "SNS",
  //         checked: false
  //       },
  //       {
  //         id: "twit1",
  //         name: "트위터",
  //         checked: false
  //       },
  //       // {
  //       //   id: "facebook1",
  //       //   name: "페이스북",
  //       //   checked: false
  //       // },
  //       {
  //         id: "insta1",
  //         name: "인스타그램",
  //         checked: false
  //       },
  //       // {
  //       //   id: "youtube",
  //       //   name: "유튜브",
  //       //   checked: false,
  //       // },
  //       {
  //         id: "video0",
  //         name: "동영상",
  //         checked: false
  //       },
  //       {
  //         id: "youtube1",
  //         name: "유튜브",
  //         checked: false
  //       }
  //     ]
  //   },
  //   {
  //     id: "news",
  //     name: "뉴스미디어",
  //     checked: false,
  //     subCh: [
  //       {
  //         id: "pnews0",
  //         name: "포털뉴스",
  //         checked: false
  //       },
  //       {
  //         id: "tnews0",
  //         name: "종합일간지",
  //         checked: false
  //       },
  //       {
  //         id: "inews0",
  //         name: "인터넷 언론",
  //         checked: false
  //       },
  //       {
  //         id: "bnews0",
  //         name: "방송사",
  //         checked: false
  //       },
  //       {
  //         id: "enews0",
  //         name: "경제전문지",
  //         checked: false
  //       },
  //     ]
  //   },
  //   {
  //     id: "shop",
  //     name: "상품평",
  //     checked: false,
  //     subCh: [
  //       {
  //         id: "ashop0",
  //         name: "옥션",
  //         checked: false
  //       },
  //       {
  //         id: "gshop0",
  //         name: "지마켓",
  //         checked: false
  //       },
  //       {
  //         id: "eshop0",
  //         name: "11번가",
  //         checked: false
  //       },
  //       {
  //         id: "cshop0",
  //         name: "쿠팡",
  //         checked: false
  //       },
  //       {
  //         id: "wshop0",
  //         name: "위메프",
  //         checked: false
  //       },
  //       {
  //         id: "tshop0",
  //         name: "티몬",
  //         checked: false
  //       },
  //     ]
  //   },
  //   {
  //     id: "renews",
  //     name: "포털뉴스 댓글",
  //     checked: false,
  //     subCh: []
  //   },
  //   // {
  //   //   id: "youtube",
  //   //   name: "유튜브",
  //   //   checked: false,
  //   //   subCh: []
  //   // },
  // ]);


  useEffect(() => {
    // if(props.currentRole == 'ROLE_ADMIN'){
    //   setChannels(CHANNEL_ARRAY_ADMIN_SET)
    // }else{
    //   setChannels(CHANNEL_ARRAY_SET)
    // }

    getExpressParams('/query/query-label/userid/all', {
      email: props.currentUser
    }, (response)=>{
      setLabelList(response.data.BuzzLabel);
      setQueryList(response.data.queryentity);
      setQuerySelectOption(toQuerySelectList(response.data.queryentity, response.data.BuzzLabel));
      setMultiQuerySelectOption(toQuerySelectList(response.data.queryentity, response.data.BuzzLabel));
    })

    setReportTypeSelectOption(toReportTypeList());
    // setChannelSelectOption(toChannelList());

    getUserLabelData((res)=>setUserLabelData(res));
    getExpressParams('/users/role/userid', {
      email: props.currentUser
    }, (response) => {
      setUserRole(response.data[0].role)
    })
  }, [])

  useEffect(()=>{
    if (!mainQuery){
      setSubQuery([])
      setMultiQuerySelectOption(toQuerySelectList(queryList, labelList))
    }
    else{
      setSubQuery([]);
      setMultiQuerySelectOption(toMultiQuerySelectList(mainQuery, queryList, labelList));
    }
  }, [mainQuery])

  const getUserLabelData = (callback) => {
    getExpressParams('/query/label/userid/all', {
      email: props.currentUser
    }, (response) => {
      callback(response.data.BuzzLabel.info);
    })
  }

  const handleDateBtn = (e) => {
    const date = e.target.getAttribute('name');
    let end_date = new Date();
    end_date.setFullYear(end_date.getFullYear(), end_date.getMonth(), end_date.getDate()-1);

    if(props.currentRole=='ROLE_USER_04'){
      let start_date = new Date();
      start_date.setFullYear(start_date.getFullYear(), start_date.getMonth(), start_date.getDate()-7);
      setDate([start_date, end_date]);
      setOnDateBtn("w1")
      return;
    }

    switch (date) {
      case "1week":{
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth(), start_date.getDate()-7);
        setDate([start_date, end_date]);
        setOnDateBtn("w1")
        break;
      }
      case "2week":{
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth(), start_date.getDate()-14);
        setDate([start_date, end_date]);
        setOnDateBtn("w2")
        break;
      }
      case "1month":{
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth()-1);
        setDate([start_date, end_date]);
        setOnDateBtn("m1")
        break;
      }
      case "3month":{
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth()-3);
        setDate([start_date, end_date]);
        setOnDateBtn("m3")
        break;
      }
      default:
        break;
    }
  }

  const handleDate = (selectedDateRange) => {
    setDate(selectedDateRange)
    setOnDateBtn("nope")
  }

  const selectReportType = (e) => {
    if (e) {
      let pushItem = [];
      e.forEach(item=>pushItem.push(item.value))
      setReportType(pushItem);
    }
    else {
      setReportType([]);
    }
  }

  // const selectChannel = (e) => {
  //   if (e) {
  //     let pushItem = [];
  //     e.forEach(item=>pushItem.push(item.value))
  //     setChannels(pushItem);
  //   }
  //   else{
  //     setChannels([]);
  //   }
  // }
  const handleChannels = (type, id, value) => {
    switch(type) {
      case "channel": {
        setChannels(
          produce(channels, (draft) => {
            const ch = draft.find(item => item.id == id);
            ch.checked = value;
          })
        )
        break;
      }
      case "subChannel" :{
        setChannels(
          produce(channels, (draft) => {
            const ch = draft.find(channel=>channel.subCh.find(item=> item.id==id));
            const subch = ch.subCh.find(item=>item.id==id);
            subch.checked = value;
          })
        )
        break;
      }
      default:
        break;
    }
  } 
  const handleSubQueryType = (e) => {
    const type = e.target.getAttribute('name');

    setSubQueryType(type);
  }

  const selectMainQuery = (e) => {
    if (e) {
      setMainQuery(e.id);
    }
    else {  
      setMainQuery(null);
    }
  }

  const selectSubQuery = (e) => {
    if (e) {
      let pushItem = [];
      e.forEach(item=>pushItem.push(item.id))
      setSubQuery(pushItem);
    }
    else {
      setSubQuery([]);
    }
  }

  const setReportJSON = () => {
    let retJSON = {
      dateRange: [(dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "") ,
      (dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "")],
      sub_query_type: subQueryType,
      retwit: reTweet,
      // reportType: reportType,
      name: "결과_미리보기",
      // channel: channels
      morph: options.morph
    }

    const retChannels = [];
    channels.forEach((ch)=>{
      if (ch.checked) retChannels.push(ch.id);
      ch.subCh.forEach((subch)=>{
        if(subch.checked) retChannels.push(subch.id)
      })
    })    
    retJSON.channel = retChannels;

    const retQuery = [];
    let pushItem = queryList.info.find((item)=>item.queryID==mainQuery)
    retQuery.push({
      "name": pushItem.name,
      "type": pushItem.QUERY_TYPE,
      "content": JSON.parse(pushItem.content)
    })

    subQuery.forEach(item=>{
      pushItem = queryList.info.find((query)=>query.queryID==item);
      retQuery.push({
        "name": pushItem.name,
        "type": pushItem.QUERY_TYPE,
        "content": JSON.parse(pushItem.content)
      })
    });
    retJSON.query = retQuery;

    return retJSON
  }

  const handleLoadingText = () => {
    let outputBaseQuery = queryList.info.find(item=>item.queryID==mainQuery).name;
    let outputSubQuery = [];
    subQuery.forEach(subQueryItem=>{
      outputSubQuery.push(queryList.info.find(item=>item.queryID==subQueryItem).name)
    });
    // let outputChannel = [];
    // channels.forEach(channelItem=>{
    //   outputChannel.push(Channel_CODE_SET[channelItem])
    // })
    let outputChannel = [];
    const retChannels = [];
    channels.forEach((ch)=>{
      if (ch.checked) retChannels.push(ch.id);
      ch.subCh.forEach((subch)=>{
        if(subch.checked) retChannels.push(subch.id)
      })
    })    
    retChannels.forEach(channelItem=>{
      outputChannel.push(Channel_CODE_SET[channelItem])
    })
    let outputReportType = [];
    reportType.forEach(reportItem=>{
      outputReportType.push(REPORT_TYPE_SET[reportItem])
    })

    setLoadingText(
    <span style={{textAlign: "left"}}>
      <div>
        Date: {(dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "-")} ~ {(dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "-")}
      </div>
      <div>
        BaseKeyword: {outputBaseQuery}
      </div>
      {subQuery.length != 0 ?
      <>
        <div>
          SubKeyword: {outputSubQuery.map((item,index)=>{
            if (index==outputSubQuery.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)
          })}
        </div>
        <div>
          SubKeywordType: {subQueryType=="compare"? "비교" : "교차"}
        </div>
      </>
      :undefined}
      <div>
        Channel: {outputChannel.map((item,index)=>{
            if (index==outputChannel.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)        
        })}
      </div>
      <div>
        Report Type: {outputReportType.map((item,index)=>{
            if (index==outputReportType.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)        
        })}
      </div>
    </span>
    )
  }

  const handleRunBtn = () => {
    const retJSON = setReportJSON();
    setVolumeResult(null);
    setSentimentResult(null);
    setSourceResult(null);
    setRelationResult(null);
    setCategoryResult(null);
    setPositioningmapResult(null);

    setLoaded(false);
    handleLoadingText();
    let count = 0;
    reportType.forEach(reportTypeItem=>{
      count++;
      getExpressParams(`/report/${reportTypeItem}/json`,{
        email: props.currentUser,
        json: {
          ...retJSON,
          reportType: reportTypeItem
        }
      }, (response) => {
        count--;
        if( count ==0 ) {
          setLoaded(true)
          setLoadingText(<div>loadng</div>)
        }
        if(response.data.success){
          switch(reportTypeItem){
            case "volume": {
              setVolumeResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "sentiment": {
              setSentimentResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "source": {
              setSourceResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "relation": {
              setRelationResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "category": {
              setCategoryResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "positioningmap": {
              setPositioningmapResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            default:
              break;
          }
        }
        else{
          handleAlertShow();
        }
      })
    })
  }

  const snapshotSave = (snapshotName, labelName, labelID) => {

    const selectedChannels = [];
    channels.forEach((ch)=>{
      if (ch.checked) selectedChannels.push(ch.id);
      ch.subCh.forEach((subch)=>{
        if(subch.checked) selectedChannels.push(subch.id)
      })
    })
    
    postExpress('/query/snapshot-label/userid', {
      "snapshotName": snapshotName,
      "labelName": labelName,
      "labelID": labelID,
      "email": props.currentUser,
      "content": {
        "date": [(dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "") ,
        (dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "")],
        "reTweet": reTweet,
        // "channels": channels,
        "channels": selectedChannels,
        ...options
      },
      "mainQuery": mainQuery,
      "subQuery": subQuery,
      "subQueryType": subQueryType,
      "snapshotType": reportType,
    },
    (res)=>{
    })
    getUserLabelData((res)=>setUserLabelData(res));
  }

  return (
    <>
      <AlertModal alertShow={alertShow} handleAlertClose={handleAlertClose} handleAlertShow={handleAlertShow} />
      <LoadingOverlay
      active={!loaded}
      spinner={true}
      text={loadingText}>
        <SnapshotCreateMain handleRunBtn={handleRunBtn} minDate={SNAPSHOT_RANGE()} handleDate={handleDate} dateRange={dateRange} handleDateBtn={handleDateBtn}
          reportTypeSelectOption={reportTypeSelectOption} selectReportType={selectReportType}
          // channelSelectOption={channelSelectOption} selectChannel={selectChannel}
          channels={channels} handleChannels={handleChannels}
          querySelectOption={querySelectOption} selectMainQuery={selectMainQuery} mainQuery={mainQuery}
          multiQuerySelectOption={multiQuerySelectOption} subQueryType={subQueryType} selectSubQuery={selectSubQuery} handleSubQueryType={handleSubQueryType}
          volumeResult={volumeResult} sentimentResult={sentimentResult} sourceResult={sourceResult} categoryResult={categoryResult} relationResult={relationResult} positioningmapResult={positioningmapResult}
          options={options} userLabelData={userLabelData} handleSaveBtn={snapshotSave} onDateBtn={onDateBtn} userRole={userRole}
        />
      </LoadingOverlay>
     </>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  currentRole: state.AuthManager.status.currentRole

});
export default connect(mapStateToProps)(SnapshotCreate);